import * as angular from 'angular';

import { ActualDataType, AggregationMode, ComponentDefinition, IdentifierType, ScriptType } from '../../../models/index';
import { IStoreService } from '@services/store.service';
import { StoreElement } from '../../../stateManagement';
import { IFileManagementService } from '@services/general';

interface ModelStatistics {
    groupsCount: number;
    connectionPointsCount: number;
    identifiersCount: {
        aggregated: number;
        calculated: number;
        linked: number;
        measured: number;
        target: number;
        validated: number;
    };
    librariesCount: {
        v2: number;
        v3: number;
    }
    tagsCount: {
        float: number;
        digital: number;
    }
}


class ModelStatisticsStateController implements angular.IComponentController {
    isLoading: boolean;
    isStoreLoading: boolean;
    loadingMessage: string;
    rows: { icon: string, label: string, count: number }[];

    static $inject = ['$q', 'fileManagementService', 'storeService'];
    constructor(
        private _$q: angular.IQService,
        private _fileManagementService: IFileManagementService,
        private _storeService: IStoreService
    ) {
    }

    $onInit() {
        this.rows = [];
        let statistics: ModelStatistics = {} as any;
        this.isLoading = true;
        this._$q.all(
            [
                this._fileManagementService.getAllScriptLibraries(ScriptType.PythonV2),
                this._fileManagementService.getAllScriptLibraries(ScriptType.PythonV3)
            ]
        )
            .then(responses => {
                statistics = Object.assign({}, statistics, { librariesCount: { v2: responses[0].length, v3: responses[1].length } });
                this.rows = this.updateRows(statistics);
            });
        this.isStoreLoading = true;
        this._storeService.register(store => {
            const tags = Object.values(store.tags.dictionary);
            const identifiers = Object.values(store.identifiers.dictionary);
            const connectionPoints = Object.values(store.connectionPoints.dictionary);
            statistics = Object.assign({}, statistics,
                {
                    groupsCount: Object.keys(store.groups.dictionary).length,
                    tagsCount: {
                        float: tags.filter(d => d.actualDataType === ActualDataType.Float).length,
                        digital: tags.filter(d => d.actualDataType === ActualDataType.Digital).length
                    },
                    connectionPointsCount: connectionPoints.length,
                    identifiersCount: {
                        aggregated: identifiers.filter(i => i.type === IdentifierType.CalculatedValue && i.aggregationMode !== AggregationMode.None).length,
                        calculated: identifiers.filter(i => i.type === IdentifierType.CalculatedValue && i.aggregationMode === AggregationMode.None).length,
                        linked: identifiers.filter(i => i.type === IdentifierType.Linked).length,
                        measured: identifiers.filter(i => i.type === IdentifierType.Tag).length,
                        target: identifiers.filter(i => i.type === IdentifierType.Target).length,
                        validated: identifiers.filter(i => i.type === IdentifierType.Validated).length,
                    }
                });
            this.rows = this.updateRows(statistics);
            this.isStoreLoading = false;
        }, [StoreElement.Groups, StoreElement.Tags, StoreElement.Identifiers, StoreElement.ConnectionPoints]);
    }

    private updateRows(statistics: ModelStatistics) {
        return [
            { icon: 'fa-sitemap', label: 'Groups', count: statistics.groupsCount },
            { icon: 'fa-code', label: 'V2 libraries', count: statistics.librariesCount?.v2 },
            { icon: 'fa-code-fork', label: 'V3 libraries', count: statistics.librariesCount?.v3 },
            { icon: 'fa-hashtag', label: 'Float tags', count: statistics.tagsCount?.float },
            { icon: 'fa-list-ol', label: 'Digital tags', count: statistics.tagsCount?.digital },
            { icon: 'fa-connectdevelop', label: 'Connection points', count: statistics.connectionPointsCount },
            { icon: 'fa-tag', label: 'Measured identifiers', count: statistics.identifiersCount?.measured },
            { icon: 'fa-calculator', label: 'Calculated identifiers', count: statistics.identifiersCount?.calculated },
            { icon: 'fa-plus-circle', label: 'Aggregated identifiers', count: statistics.identifiersCount?.aggregated },
            { icon: 'fa-check-square-o', label: 'Validated identifiers', count: statistics.identifiersCount?.validated },
            { icon: 'fa-bullseye', label: 'Target identifiers', count: statistics.identifiersCount?.target },
        ];
    }
}

export const wtModelStatisticsState: ComponentDefinition = {
    componentId: 'wtModelStatisticsState',
    controller: ModelStatisticsStateController,
    template: require('./modelStatisticsState.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};
